import { adminLogin } from "../../Api/SubUrl";
import { Navigate } from "react-router-dom";
import { handleGetToken } from "../Func/Storage";
export const ProtectedRoute = ({ type, children }) => {
  let token = handleGetToken();

  if (!token) {
    return <Navigate to={adminLogin} replace />;
  }

  return children;
};
